import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import './style.css'

const GroupCheckbox = ({data, handleChange, disabled}) => {

	const [checkedItems, setCheckedItems] = useState(data.options?.reduce((acc, option) => {
		acc[option.nameForm] = option.value || data.uncheckedValue || false;
		return acc;
	}, {}))

	const handleCheck = (e, option) => {
		setCheckedItems({...checkedItems, [option]: e.target.checked ? data.checkedValue : data.uncheckedValue})

		for (let key in checkedItems) {
			if (key === option) {
				handleChange({target: {name: option, value: e.target.checked ? data.checkedValue : data.uncheckedValue}})
			}
		}
	}


	const checkboxes = data.options?.map((option, index) => (
    <Form.Check
			key={index}
			id={`${data.nameForm}-${data.type}-${index}`}
			type="checkbox"
			label={option.text}
			required={data.required}
			name={data.nameForm}
			disabled={disabled}
			onChange={e => handleCheck(e, option.nameForm)}
			checked={checkedItems[option.nameForm] === data.checkedValue ? true : false}
		/>
  ));

  // Divide em colunas
	const columns = data.columns || 1;
  const itemsPerColumn = Math.ceil(data.options?.length / columns);
  const columnsArray = Array.from({ length: columns }, (_, colIndex) => {
    const start = colIndex * itemsPerColumn;
    const end = start + itemsPerColumn;
    return (
      <Col key={colIndex} xs={12} sm={12} md={12 / columns}>
        {checkboxes?.slice(start, end)}
      </Col>
    );
  });


  return (
    <Form.Group className={data.class} controlId={data.nameForm}>
			{data.name && <Form.Label>{data.name}</Form.Label>}
			<Row>{columnsArray}</Row>
		</Form.Group>
  )
}

export default GroupCheckbox
